import jsonLogic from '@/plugins/jsonLogic'
import SimpleText from '@/agilis/components/Text/Text.vue'

export default {
  name: 'MetricTitle',
  components: {
    SimpleText
  },
  props: {
    metric: {
      type: Object,
      required: true
    },
    items: [Array, Number, String],
    result: {
      type: [String, Number, Object],
      required: false
    }
  },
  computed: {
    icon () {
      const icon = { value: this.metric.icon }
      const decorations = this.metric.style || {}

      if (decorations.icon) {
        icon.value = jsonLogic.apply(decorations.icon.jsonLogic, { result: this.result, items: this.items })
      }
      if (decorations.iconColor) {
        icon.color = decorations.iconColor.jsonLogic
          ? jsonLogic.apply(decorations.iconColor.jsonLogic, { result: this.result, items: this.items })
          : decorations.iconColor
      }
      return icon
    }
  }
}
